import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <nav className="navbar fixed-top navbar-expand-lg navbar-light bg-dark">
      <div className="container">
        <a className="navbar-brand">
          <span className="orange">C</span>y<span className="orange">B</span>o
          <span className="orange">R</span>g
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <FontAwesomeIcon
            icon={faBars}
            style={{ color: "#fff", fontSize: "1.875rem" }}
          />
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item" id="1">
              <Link
                className="nav-link active"
                aria-current="page"
                to="/"
                id="home"
              >
                Home
              </Link>
            </li>
            <li className="nav-item" id="2">
              <a className="nav-link" href="#services">
                Services
              </a>
            </li>
            <li className="nav-item" id="3">
              <a className="nav-link" href="#skills">
                Skills
              </a>
            </li>
            <li className="nav-item" id="4">
              <a className="nav-link" href="#portfolio">
                Work
              </a>
            </li>
            <li className="nav-item" id="5">
              <a className="nav-link" href="#about">
                About
              </a>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contact">
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
